import { render, staticRenderFns } from "./c-SNPMB-Soal.vue?vue&type=template&id=124f86ea&scoped=true&"
import script from "./c-SNPMB-Soal.vue?vue&type=script&lang=js&"
export * from "./c-SNPMB-Soal.vue?vue&type=script&lang=js&"
import style0 from "./c-SNPMB-Soal.vue?vue&type=style&index=0&id=124f86ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f86ea",
  null
  
)

export default component.exports